import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-store-stocks',
    templateUrl: './store-stocks.component.html',
    styleUrls: ['./store-stocks.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StoreStocksComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
